import React from 'react';
import { useTranslation } from 'react-i18next';

import { Stack } from '@mui/material';

import { DescriptionTypography } from '@/components/LoginDialog/components';

/** Local heading — Raleway heavy (700) instead of the default
 *  Cormorant 400 in `MainTextTypography`. Matches the visual weight
 *  used in other modal headings on the site (e.g. ManageAddonsModal /
 *  AccountRestoreModal title row). Kept local since this is the only
 *  RecoveryDialog step that asks for the heavier treatment. */
const Heading: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <h2
    style={{
      color: "#ffffff",
      fontFamily: "Raleway, sans-serif",
      fontSize: "1.5rem",
      fontWeight: 700,
      lineHeight: 1.2,
      letterSpacing: "0.01em",
      margin: 0,
      textAlign: "center",
    }}
  >
    {children}
  </h2>
);

const Divider: React.FC = () => (
  <div
    style={{
      width: "100%",
      height: 1,
      background: "linear-gradient(90deg, transparent, rgba(235, 194, 142, 0.3), transparent)",
    }}
  />
);

const SecondStep: React.FC = () => {
  const { t } = useTranslation('login', {
    keyPrefix: 'passwordRecovery.secondStep',
  });

  // Copy is intentionally email-agnostic ("if that email has an account
  // with us...") so a user submitting an unknown email gets the same
  // visible response as a known one — prevents account enumeration via
  // the password-reset form. Matches the backend's silent-succeed
  // behavior in AuthService.sendVerificationLinkForPassword.

  return (
    <Stack spacing="20px" width="100%" justifyContent="center" alignItems="center">
      <Heading>{t('mainText')}</Heading>
      <Divider />
      <DescriptionTypography>{t('description')}</DescriptionTypography>
    </Stack>
  );
};

export default SecondStep;
